// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFontSizeOutlinedSvg from "@fishx/icons-svg/es/asn/PFontSizeOutlined";
import FishxIcon from '../components/FishxIcon';

var PFontSizeOutlined = function PFontSizeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFontSizeOutlinedSvg
  }));
};

PFontSizeOutlined.displayName = 'PFontSizeOutlined';
export default React.forwardRef(PFontSizeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFontSizeOutlined.js
// module id = 3423
// module chunks = 0